import { useEffect, useState } from "react";
import Title from "../../components/title/Title";
import axios from "axios";
import { useHistory } from "react-router-dom";

import "./Management.css";
import FarmEditor from "./farm/FarmEditor";

const Management = () => {
  const [reports, setReports] = useState([]);
  const [farms, setFarms] = useState([]);
  const history = useHistory();
  const [displayFarmEditor, setDisplayFarmEditor] = useState(false);

  useEffect(() => {
    getFarms();
    getReports();
  }, []);

  const getFarms = async () => {
    try {
      const response = await axios.get("/api/farms", {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setFarms(response.data);
    } catch (error) {}
  };

  const getReports = async () => {
    try {
      const response = await axios.get("/api/reports", {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setReports(response.data);
    } catch (error) {}
  };

  const addFarm = () => {
    setDisplayFarmEditor(true);
  };

  const addReport = () => {
    console.log("add report");
  };

  const onAddNewFarmSuccess = (farm) => {
    setDisplayFarmEditor(false);
    sessionStorage.setItem("name", farm.name);
    history.push(`/dashboard/farm/${farm._id}`);
  }

  return (
    <div id="management">
      <div>
        <Title text="חוות" onAddButtonClick={addFarm} />
        <div>
          {farms.map((farm) => {
            return <FarmCard key={farm._id} farm={farm} />;
          })}
        </div>
      </div>
      <div id="reports2">
        <Title text="דוחות" onAddButtonClick={addReport} />
        <table border="1">
          <thead>
            <tr>
              <th>שם</th>
              <th>עדכון</th>
              <th>מחיקה</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report, index) => {
              return (
                <tr key={index}>
                  <td>{report.name}</td>
                  <td className="edit">עדכון</td>
                  <td className="delete">מחיקה</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {displayFarmEditor && <FarmEditor visible={displayFarmEditor} onSuccess={onAddNewFarmSuccess} onCancel={() => {setDisplayFarmEditor(false)}} />}
    </div>
  );
};

const FarmCard = ({ farm }) => {

  const history = useHistory();

  const onFarmClicked = () => {
    sessionStorage.setItem("name", farm.name);
    history.push(`/dashboard/farm/${farm._id}`);
  };

  return (
    <div className="farmCard" onClick={onFarmClicked}>
      <div>
        <span id="farmName">{farm.name}</span>
      </div>
    </div>
  );
};

export default Management;
